"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenImageIcon = void 0;
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var theme_1 = require("../../components/theme");
var hidden_image_icon_style_1 = require("./hidden.image.icon.style");
(0, theme_1.addStyles)(hidden_image_icon_style_1.Style);
exports.HiddenImageIcon = {
    view: function (opts) {
        if (opts === void 0) { opts = { position: 'center' }; }
        return icon_1.Icon.view(icons_1.MaterialIcon.VISIBILITY_OFF, { className: "".concat(hidden_image_icon_style_1.ClassNames.icon, " ").concat(hidden_image_icon_style_1.ClassNames.position[opts.position]) });
    }
};
//# sourceMappingURL=hidden.image.icon.js.map